/** Revanista Web Application entry point */

import { createRoot } from "react-dom/client";
import "react-toastify/dist/ReactToastify.css";
import App from "./App/App";
import * as serviceWorker from "./serviceWorker";
import "./styles/index.scss";
import { Provider as ReduxProvider } from "react-redux";
import { store } from "./redux/store";
import React from "react";
import { enableMapSet } from "immer";

// Enable Map and Set support for Immer (used by Redux Toolkit)
enableMapSet();

const ROOT = (
  <ReduxProvider store={store}>
    <App />
  </ReduxProvider>
);
const container = document.getElementById("root");
if (container) {
  const root = createRoot(container);
  root.render(ROOT);
}
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
